import { render, staticRenderFns } from "./AssignTaskDetail.vue?vue&type=template&id=356c7ff9&"
import script from "./AssignTaskDetail.vue?vue&type=script&lang=js&"
export * from "./AssignTaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssignTaskDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports